import axios from 'axios';

import customer from '../customer';
const {getActiveSubscriptionId} = customer.selectors;

import * as endpoints from '../common/apiEndpoints';
import * as types from './actionTypes';

export function getCareSheetSettings() {
  return function(dispatch, getStore) {
    dispatch({
      type: types.GET_CARESHEET_SETTINGS
    });

    const subscriptionId = getActiveSubscriptionId(getStore());
    axios.get(`${endpoints.CARESHEET_SETTINGS}?subscriptionID=${subscriptionId}`)
      .then((response) => {
        dispatch(settingsReceived(response.data));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}

function settingsReceived(settings) { 
  let petTypeAds = [];
  const ads = settings.PetTypeAds;
  Object.keys(ads).forEach(function(key) {
    let petTypeAd = {
      petType: key,
      imageUrl: ads[key],
      isValid: (ads[key] !== null) ? true : false
    };
    petTypeAds.push(petTypeAd);
  });

  let petTypePreviews = [];
  const previews = settings.PetTypePreviews;
  Object.keys(previews).forEach(function(key) {
    let petTypePreview = {
      petType: key,
      previewUrl: previews[key]
    };
    petTypePreviews.push(petTypePreview);
  });

  return {
    type: types.CARESHEET_SETTINGS_RECEIVED,
    payload: {
      ads: petTypeAds,
      previews: petTypePreviews,
      store: {
        infoLine1: settings.InfoLine1,
        infoLine2: settings.InfoLine2,
        infoLine3: settings.InfoLine3,
        infoLine4: settings.InfoLine4,
        useLogo: settings.UseLogo,
        logoUrl: settings.LogoUrl,
        previewUrl: settings.PreviewCareSheetUrl
      } 
    }
  };
}

export function selectAd(ad) {
  return {
    type: types.AD_SELECTED,
    payload: {
      ad: ad
    }
  };
}

export function deselectAd() {
  return {
    type: types.AD_DESELECTED
  };
}

export function deleteAd(ad) {
  return function(dispatch, getStore) {
  // TODO: should we dispatch a delete attempt?
    const subscriptionId = getActiveSubscriptionId(getStore());
    const queryString = `?subscriptionID=${subscriptionId}&petType=${ad.petType}`;
    axios.delete(`${endpoints.CARESHEET_SETTINGS_AD}${queryString}`)
      .then((response) => {
        dispatch({
          type: types.AD_DELETED
        });
        dispatch(settingsReceived(response.data));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });

  };
}

export function uploadAd(ad, file) {
  return function(dispatch, getStore) {
    let fd = new FormData();
    fd.append('filename', file);
    const config = {headers: {'Content-Type': 'multipart/form-data'}};

    const subscriptionId = getActiveSubscriptionId(getStore());
    const queryString = `?subscriptionID=${subscriptionId}&petType=${ad.petType}`;
    
    axios.post(`${endpoints.CARESHEET_SETTINGS_AD}${queryString}`, fd, config)
      .then((response) => {
        dispatch(settingsReceived(response.data));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}

export function saveStoreSettings(storeInfo) {
  return function(dispatch, getStore) {
    const subscriptionId = getActiveSubscriptionId(getStore());

    const storeInfoPost = {
      'InfoLine1': storeInfo.line1,
      'InfoLine2': storeInfo.line2,
      'InfoLine3': storeInfo.line3,
      'InfoLine4': storeInfo.line4,
      'UseLogo': storeInfo.useLogo
    };

    return new Promise((resolve, reject) => {
      axios.post(`${endpoints.CARESHEET_SETTINGS_INFO}?subscriptionID=${subscriptionId}`, storeInfoPost)
        .then((response) => {
          dispatch(settingsReceived(response.data));
          resolve();
        })
        .catch(() => {
          dispatch({type: types.SHOW_ERROR_MODAL});
          reject();
        });
    });
  };
}

export function uploadLogo(file) {
  return function(dispatch, getStore) {
    const subscriptionId = getActiveSubscriptionId(getStore());
    
    let fd = new FormData();
    fd.append('filename', file);
    const config = {headers: {'Content-Type': 'multipart/form-data'}};

    axios.post(`${endpoints.CARESHEET_SETTINGS_LOGO}?subscriptionID=${subscriptionId}`, fd, config)
      .then((response) => {
        dispatch(settingsReceived(response.data));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}

export function getCareSheets() {
  return function(dispatch, getStore) {
    const subscriptionId = getActiveSubscriptionId(getStore());

    axios.get(`${endpoints.CARESHEET_LISTING}?subscriptionID=${subscriptionId}`)
      .then((response) => {
        dispatch(careSheetListReceived(response.data));
        dispatch(parsePetTypes(response.data));
      })
      .catch(() => {
        dispatch({type: types.SHOW_ERROR_MODAL});
      });
  };
}

function careSheetListReceived(careSheetList) {
  return function(dispatch) {
    dispatch({
      type: types.CARESHEET_LIST_RECEIVED,
      payload: {
        caresheets: careSheetList 
      }
    });
  };
}

function parsePetTypes(careSheetList) {
  return function(dispatch) {
    let petTypeSet = new Set([]);
    careSheetList.forEach((careSheet) => {
      petTypeSet.add(careSheet.Type);
    });
    
    const petTypeList = [];
    petTypeSet.forEach((petType) => {
      petTypeList.push(petType);
    });

    dispatch({
      type: types.PET_TYPES_ADDED,
      payload: {
        petTypes: petTypeList,
        selectedPetTypes: petTypeList
      }
    });
  };
}

export function toggleSelectedPetType(petType) {
  return function(dispatch) {
    dispatch({
      type: types.TOGGLE_SELECTED_PET_TYPE,
      payload: {
        petType: petType
      }
    });
    dispatch(filterCareSheets());
  };
}

function setSearchPhrase(searchPhrase) {
  return {
    type: types.CARESHEET_SEARCH_PHRASE,
    payload: {
      searchPhrase: searchPhrase
    }
  };
}

function filterCareSheets() {
  return {
    type: types.FILTER_CARESHEETS
  };
}

export function searchCareSheets(searchPhrase) {
  return function(dispatch) {
    dispatch(setSearchPhrase(searchPhrase));
    dispatch(filterCareSheets());
  };
}

export function clearSearchResults() {
  return {
    type: types.CLEAR_SEARCH_RESULTS
  };
}


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/actions.js
 **/